module.exports = __webpack_public_path__ + "img/tango-logo.94b7a540.svg";